
import { Mixins, Component } from 'vue-property-decorator'

import MixinInterface from '@/_mixins/index'

import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'

@Component({
    components: { ToolbarComponent },
    mixins: [],
})
export default class AddWidget extends Mixins<MixinInterface>() {
    snackbar = false
    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    projects(permission: string): Array<any> {
        return Object.values(this.$store.getters.projects).filter((project: any) => {
            return this.hasPermission(project.attributes.permissions, permission)
        })
    }

    // get projects(){
    //     return []
    //     // this.filterProjectByCurrentPermission(this.$store.getters.projects, this.permissions)
    // }

    get dashboardId() {
        return this.$route.params.dashboardId
    }

    get activeModules() {
        return this.$store.getters.projectModules
    }

    hasModule(name: string) {
        let res = Object.values(this.activeModules).find((item: any) => {
            return item?.attributes.isAccessible && item.relationships.module.data.id == name
        })
        return res ? true : false
    }

    addWidget(widget: any) {
        let data = {
            type: widget.type,
            id: Date.now(),
            name: this.$t(`dashboard.${widget.type.toLowerCase()}`),
            placement: {
                default: {
                    h: 2,
                    w: 4,
                    minW: 4,
                    minH: 2,
                },
                mobile: {},
                tablet: {},
                ...widget.placement,
            },
            settings: {
                default: {
                    requestUrl: '',
                },
                mobile: {},
                tablet: {},
                ...widget.settings,
            },
        }

        this.$store.commit('addWidget', data)
        this.snackbar = true
    }

    get HSEInfoWidget() {
        return {
            type: 'HSEInfoWidget',
            placement: {
                default: {
                    h: 2,
                    w: 4,
                    minW: 4,
                    minH: 2,
                },
            },
            settings: {
                default: {
                    project: this.projects('view_hse_board')[0].id,
                    // requestUrl: `${this.url_project}/projects/${this.projects[0].id}`
                },
            },
        }
    }

    get HSEInfoPublicWidget() {
        return {
            type: 'HSEInfoPublicWidget',
            placement: {
                default: {
                    h: 2,
                    w: 4,
                    minW: 4,
                    minH: 2,
                },
            },
            settings: {
                default: {
                    project: this.projects('view_hse_board')[0].id,
                    // requestUrl: `${this.url_project}/projects/${this.projects[0].id}`
                },
            },
        }
    }

    get HSEContactWidget() {
        return {
            type: 'HSEContactWidget',
            placement: {
                default: {
                    h: 2,
                    w: 4,
                    minW: 4,
                    minH: 2,
                },
            },
            settings: {
                default: {
                    project: this.projects('view_hse_board')[0].id,
                },
            },
        }
    }

    get HSEContactPublicWidget() {
        return {
            type: 'HSEContactPublicWidget',
            placement: {
                default: {
                    h: 2,
                    w: 4,
                    minW: 4,
                    minH: 2,
                },
            },
            settings: {
                default: {
                    project: this.projects('view_hse_board')[0].id,
                },
            },
        }
    }

    get HSEDocumentWidget() {
        return {
            type: 'HSEDocumentWidget',
            placement: {
                default: {
                    h: 2,
                    w: 4,
                    minW: 4,
                    minH: 4,
                },
            },
            settings: {
                default: {
                    project: this.projects('view_hse_board')[0].id,
                },
            },
        }
    }

    get HSEDocumentPublicWidget() {
        return {
            type: 'HSEDocumentPublicWidget',
            placement: {
                default: {
                    h: 2,
                    w: 4,
                    minW: 4,
                    minH: 4,
                },
            },
            settings: {
                default: {
                    project: this.projects('view_hse_board')[0].id,
                },
            },
        }
    }

    get ObservationStatWidget() {
        return {
            type: 'ObservationStatWidget',
            placement: {
                default: {
                    h: 2,
                    w: 4,
                    minW: 4,
                    minH: 4,
                },
            },
            settings: {
                default: {
                    project: this.project ? this.project.id : null,
                    group: this.group ? this.group.id : null,
                    chartType: 'bar',
                    aggregateFunction: 'count',
                    aggregateField: 'timePublishedToClosed',
                    aggregatePeriod: null,
                    aggregatePeriodSource: 'happenedAt',
                    groupBy: null,
                    status: [],
                    reporterIsNull: null,
                },
            },
        }
    }

    get PersonnelStatsWidget() {
        return {
            type: 'PersonnelStatsWidget',
            placement: {
                default: {
                    h: 2,
                    w: 4,
                    minW: 4,
                    minH: 4,
                },
            },
            settings: {
                default: {
                    project: this.project ? this.project.id : null,
                    group: this.group ? this.group.id : null,
                    chartType: 'bar',
                    aggregateField: 'peopleOnSite',
                    aggregatePeriod: null,
                    groupBy: null,
                },
            },
        }
    }

    // HSE TEMP CHECK
    get hasHSEAccess() {
        let result = false
        Object.values(this.$store.getters.projects).map((project: any) => {
            if (
                project.attributes.constraints.hseBoardDescription.writable ||
                project.attributes.constraints.hseContacts.writable ||
                project.attributes.constraints.hseDocuments.writable
            ) {
                result = true
            }
        })
        return result
    }
}
